<template>
  <div class="wrapper">
    <h2>{{ paidInfo.realName }} 您已付款成功！订单号为{{ paidInfo.orderNo }}</h2>
    <p>请联系老师进行学习！</p>
  </div>

</template>
<script>
import {landingPageOrder} from "../../apis/apis";
import {Toast} from "mint-ui";

export default {
  components: {},
  name: "",
  data() {
    return {
      paidInfo: {
        orderNo: "",
        realName: "",
      }

    }
  },
  methods: {
    orderInfo(oderId) {
      landingPageOrder(oderId).then((data) => {
        if ((data.code) === 200) {
          if (data.data.paid = true) {
            this.paidInfo = data.data;
            alert("支付成功")
            console.log("支付成功")
          } else {
            alert("支付失败")
            console.log("支付失败")
          }
        } else {
          Toast(data.message);
        }
      }).catch(() => {
      });
    }
  },
  mounted() {
    this.orderNo = this.$route.query.orderNo; // 获取列表页传递过来的ID
    this.orderInfo("order165450358450186571");
  }
}
</script>
<style scoped>
.wrapper {
  height: 100%;
  width: 100%;
  background: #FFFFFF;
}

h2 {
  font-size: 32px;
  line-height:70px;
}

p {
  font-size: 32px;
  line-height: 70px;
}
</style>



// WEBPACK FOOTER //
// src/pages/h5/h5OrderInfo.vue